import { GET_PROFILE_ADMINTOOLS, POST_PROFILE_ADMINTOOLS, GET_PROFILE_DETAIL_ADMINTOOLS, RESET_PROFILE_ADMINTOOLS } from "shared/constants/ActionTypes";



const Profile =  {
  id:                null,
  nama:              null,
  prefix:            null,
  suffix:            null,
  nip:               null,
  nip_alt:           null,
  objid:             null,
  email:             null,
  mobile:            null,
  officecity:        null,
  department:        null,
  show:              false,
  date_birth:        null,
  place_birth:       null,
  hierarchy:         null,
  address:           null,
  domicilecity:      null,
  working_date:      null,
  employee:          null,
  pegawai_id:        null,
  jenis_kelamin:     null,
  jenis_pegawai:     null,
  nama_jabatan:      null,
  jabatan_id:        null,
  jabatan_kode:      null,
  pendidikan:        null,
  pendidikan_tempat: null,
  rank:              null,
  rank_code:         null,
  rank_text:         null,
  echelon:           null,
  echelon_code:      null,
  echelon_text:      null,
  department_id:     null,
  department_name:   null,
  department_code:   null,
  division_id:       null,
  division_code:     null,
  division_name:     null,
  organization_id:   null,
  organization_name: null,
  organization_code: null,
  roles:             []
}

const initialState = {
  dataProfile: null,
  detailProfile:Profile
};



const profileAdmintoolsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROFILE_ADMINTOOLS:
      return {
        ...state,
        dataProfile: action.payload,
      };

    case POST_PROFILE_ADMINTOOLS:
      return {
        ...state,
        dataProfile: action.payload,
      };
      case RESET_PROFILE_ADMINTOOLS:
        return initialState
      case GET_PROFILE_DETAIL_ADMINTOOLS:
        return {
          ...state,
          detailProfile: action.payload,
        };
        default: {
          return state;
        }
  }
};

export default profileAdmintoolsReducer;
